import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSession } from '../contexts/SessionContext';
import { DefaultService } from '../generated-api';
import { isOptedOut, setOptOut, startTelemetry, trackPageView } from '../services/telemetry';

/**
 * Starts usage telemetry once the player is logged in and records a page view on
 * every route change. The server-side opt-out wins over the local flag, so an
 * opt-out made on another device also applies here.
 */
const TelemetryTracker: React.FC = () => {
  const location = useLocation();
  const { playerId } = useSession();

  useEffect(() => {
    let cancelled = false;
    const start = () => {
      if (cancelled || isOptedOut()) return;
      startTelemetry({ playerId });
      trackPageView();
    };
    DefaultService.getTelemetryPreferences()
      .then(prefs => {
        if (cancelled) return;
        if (prefs.opted_out) setOptOut(true);
        else start();
      })
      // Endpoint not deployed yet: start anyway; the first 404 switches telemetry off.
      .catch(start);
    return () => {
      cancelled = true;
    };
  }, [playerId]);

  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  return null;
};

export default TelemetryTracker;
